const ACTIONS = {
    GUEST_SELECTOR_CHANGED: 'GUEST_SELECTOR/CHANGED',
    UPDATE_GUEST_SELECTOR: 'GUEST_SELECTOR/UPDATE',
    SUBMIT_GUEST_SELECTOR: 'GUEST_SELECTOR/SUBMIT'
};

const ACTION_CREATORS = {
    guestSelectorChanged(fieldsChanged) {
        return {
            type: ACTIONS.GUEST_SELECTOR_CHANGED,
            payload: {
                fieldsChanged
            }
        };
    },
    guestSelectorDataUpdated(fieldsChanged) {
        return {
            type: ACTIONS.UPDATE_GUEST_SELECTOR,
            payload: {
                fieldsChanged
            }
        };
    },
    submitGuestSelectorModal() {
        return {
            type: ACTIONS.SUBMIT_GUEST_SELECTOR,
            payload: {}
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
